import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { ImportDocumentsService } from '../../../../components/import-documents/import-documents.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Button } from '../../../model/enum';

@Component({
  selector: 'app-common-template-tab',
  templateUrl: './common-template-tab.component.html',
  styleUrls: ['./common-template-tab.component.scss']
})
export class CommonTemplateTabComponent implements OnInit {
  flexHeight;
@Input() data:any = {}
 myForm: FormGroup;
  isModal: boolean = false;
  enumButtonName = Button;
  constructor(
    private importDocumentsService : ImportDocumentsService,
    private activeModal: NgbActiveModal,
  ) {
    // Detect if opened as a modal (NgbActiveModal is available)
    try {
      this.isModal = !!this.activeModal;
    } catch {
      this.isModal = false;
    }
  }

  ngOnInit(): void {
    this.data.templateData = this.data?.templateData || {};
    if (!this.data.templateData.selectedOption) {
      this.data.templateData.selectedOption = '1';
    }
    this.importDocumentsService.previuosTab.subscribe((res) => {
      if(this.data?.templateData?.isTemplateCreate){
        this.data.templateData.selectedOption = '1'
      }   
    })
  }
  onSubmit(){}
  get isMappingIdDisabled(): boolean {
    const id = this.data?.templateData?.mappingTemplateId;
    return id === '0' || id === '' || id === undefined;
  }

  closeModal(): void {
    this.activeModal.close({ confirm: false });
  }

  saveModal(): void {
    const selectedOption = this.data?.templateData?.selectedOption ?? '1';
    // Validate template name required when option is not 1
    if (selectedOption !== '1' && !this.data?.templateData?.templateName?.trim()) {
      this.data.templateData.isValid = true;
      return;
    }
    this.activeModal.close({
      confirm: true,
      templateData: {
        selectedOption: selectedOption,
        templateName: this.data.templateData?.templateName ?? '',
        templateDescription: this.data.templateData?.templateDescription ?? '',
        isTemplateCreate: selectedOption !== '1',
        mappingTemplateId: selectedOption === '3' ? '0' : (this.data.templateData?.mappingTemplateId ?? '0'),
      }
    });
  }
  
}
